<template>
  <div v-loading="fullScreenLoading" element-loading-text="正在登陆，请稍等...">
    <!-- 选择 -->
    <div :class="'toolItem theme-' + theme">
      客户端
    </div>
    <div class="el-input-div ">
      <img :src="options[iconVaule].icon" alt="">
      <el-select v-model="value" placeholder="请选择" @change="changeSelect">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <!-- 账号 -->
    <div class="el-input-div">
      <el-input
        class="mgtb"
        :placeholder="options[iconVaule].placeholder"
        v-model="username"
      ></el-input>
    </div>

    <!-- 密码 -->
    <div class="el-input-div">
      <el-input
        class="mgtb"
        placeholder="请输入密码"
        v-model="password"
        type="password"
        @keyup.enter="loginGo"
        show-password
      ></el-input>
    </div>

    <!-- 滑块验证码 -->
    <div class="verify-div" v-if="slideIsshow">
      <div class="slide-verify-div-box">
        <div class="slide-verify-title">
        <span>请完成安全验证码</span>
        <span @click="slideIsshow = false;slideBtnIsshow = true">x</span>
        </div>
        <div class="slide-verify-box">
          <slide-verify 
            v-if="slideIsshow"
            slider-text="拖动做左边滑块完成上方拼图"
            @success='onSuccess'
            @fail="onFail"
          ></slide-verify>
        </div>
      </div>
      <div class="mask" @click="slideIsshow = false;slideBtnIsshow = true"></div>
    </div>
    <el-button-group style="width: 100%;">
      <!-- 滑动验证码 -->
      <el-button v-show="captchatoken && slideBtnIsshow" class="verifyBtn mgtb" @click="showSlide" type="primary">点击完成验证</el-button>
      <el-button v-show="slideSuccessBtn" class="SuccessBtn mgtb"  type="primary">
        <svg t="1652076018727" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1898" width="19" height="19"><path d="M512 0C228.430769 0 0 228.430769 0 512s228.430769 512 512 512 512-228.430769 512-512S795.569231 0 512 0z m0 945.230769C271.753846 945.230769 78.769231 752.246154 78.769231 512S271.753846 78.769231 512 78.769231s433.230769 192.984615 433.230769 433.230769-192.984615 433.230769-433.230769 433.230769z" p-id="1899" fill="#43BF97"></path><path d="M716.8 330.830769l-208.738462 248.123077c-15.753846 15.753846-43.323077 19.692308-59.076923 7.876923L299.323077 472.615385c-15.753846-11.815385-43.323077-7.876923-55.138462 7.876923-11.815385 15.753846-7.876923 43.323077 7.876923 55.138461l149.661539 114.215385c19.692308 15.753846 47.261538 23.630769 74.830769 23.630769 35.446154 0 70.892308-15.753846 94.523077-43.323077l208.738462-248.123077c15.753846-15.753846 11.815385-43.323077-3.938462-55.138461-19.692308-15.753846-43.323077-15.753846-59.076923 3.938461z" p-id="1900" fill="#43BF97"></path></svg>
        验证成功
      </el-button>
  
      <!-- 登录 -->
      <el-button :class="'loginBtn mgtb loginBtn-' + theme" @click="loginGo" type="primary">登 录</el-button>
    </el-button-group>
  </div>
</template>
 
<script>
import { login, getaccesstoken, getsecurityrules, getphonemultipleaccounts } from "@/port/pages/login";
import { cloneDeep } from 'lodash'
import { encryptPassword } from '@/util/encrypt.js'
import { ElMessage } from "element-plus";

export default {
  props: {
    //- 登录失败弹窗
    loginFail: {
      type: String,
      default: ''
    },
    //- 主题色
    theme: {
      type: String,
      default: ''
    },
    isAddUser: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      username: "",
      password: "",
      captcha: "",
      fullScreenLoading: false,
      captchatoken: "",
      options: [{
        value:  1,
        label: '账号',
        icon: 'https://bigdata.topeti.com/PCRepository/mainPlatform/user.svg',
        placeholder: '请输入账号'
      },/*{
        value: 2,
        label: '身份证号',
        icon: 'https://bigdata.topeti.com/PCRepository/mainPlatform/ID.svg',
        placeholder: '请输入身份证号'
      },*/{
        value: 3,
        label: '手机号',
        icon: 'https://bigdata.topeti.com/PCRepository/mainPlatform/phone.svg',
        placeholder: '请输入手机号'
      }],
      value: 1,
      iconVaule: 0,
      // 密码输错多少次后需要滑块验证，默认2次
      captchaNum: 2,
      // 滑动验证码显示
      slideIsshow: false,
      // 滑动验证码按钮显示
      slideBtnIsshow: true,
      // 滑动验证成功后的提示
      slideSuccessBtn: false,
      // 滑动验证的返回
      isVerify: false,
      moveLength: '',
      imagecaptchatoken: ''
    };
  },
  methods: {
    // 改变选项
    changeSelect(e){
      this.iconVaule = e === 1 ? 0 : 1
    },
    //- 获取图片验证码
    getCaptcha () {
      this.captchatoken = (Math.random() * 10).toString().slice(-6);
    },
    // 显示滑动验证码
    showSlide(){
      this.slideIsshow = !this.slideIsshow
      this.slideBtnIsshow = false
    },
    // 滑块验证码的回调
    onSuccess(e){
      this.imagecaptchatoken = e.imagecaptchatoken
      this.moveLength = e.moveLength
      this.slideIsshow = false
      this.slideSuccessBtn = true
      this.isVerify = true
    },
    onFail(){

    },
    onRefresh(){
        console.log('刷新');
    },
    // 去掉账号前后多余空格
    trim(str){   
      str = str.replace(/^(\s|\u00A0)+/,'');   
      for(var i=str.length-1; i>=0; i--){   
          if(/\S/.test(str.charAt(i))){   
              str = str.substring(0, i+1);   
              break;   
          }   
      }   
      return str;
    },
    async accountAndIdLogin(obj) {
      const res = await login(obj).catch(() => { this.fullScreenLoading = false })
      return res
    },
    async toLogin(res, Num) {
      if (res.code === 0) {
        if (this.isAddUser) {
          let data = res.data
          let users = []
          const info = localStorage.getItem('userList')
          if (Array.isArray(res.data)) {
            data = res.data[0]
          }
          if (info) {
            users = JSON.parse(info)
            const idx = users.findIndex(c=>c.userId === data.userId)
            if (idx !== -1) {
              users.splice(idx,1)
            }
          }
          users.unshift(data)
          if (users.length >= 10) {
            users.splice(users.length - 1, 1)
          }
          localStorage.setItem('userList',JSON.stringify(users))
        }
        this.$store.state.postUrl = [];
        if(Object.prototype.hasOwnProperty.call(res.data, 'listschool')){
          res.data.schoolMsg = res.data.listschool[0];
          localStorage.setItem("userMsg", JSON.stringify(res.data));
          this.loginToken(res.data.listschool[0].schoolId, res.data.userId, Num)
        }
        else{
          res.data[0].schoolMsg = res.data[0].listschool[0]
          localStorage.setItem("userMsg", JSON.stringify(res.data[0]));
          this.loginToken(res.data[0].listschool[0].schoolId, res.data[0].userId, Num)
        }
      } else {
        this.fullScreenLoading = false;
        ElMessage({
          type: 'error',
          message: res.msg
        })
        console.log('asdasdada', this.slideSuccessBtn , (res.data && res.data.num && res.data.num >= this.captchaNum))
        if (this.slideSuccessBtn || (res.data && res.data.num && res.data.num >= this.captchaNum)) {
          this.getCaptcha();
          this.slideBtnIsshow = true
          this.slideSuccessBtn = false
          this.isVerify = false
        }
      }
    },
    //- 登录
    async loginGo () {
      this.$emit("onclearStorage");
      this.fullScreenLoading = true;
      //获取6位随机数，下面accesstoken要用
      let Num = "";
      for (let i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      let date = {
        username: this.trim(this.username),
        password: this.password,
        accesstoken: Num,
        accounttype: this.value,
        smtype: 1 //密码国密加密
      };

      if(date.username.length == 0){
        ElMessage({
          type: 'error',
          message: '账号不能为空'
        })
        this.fullScreenLoading = false;
        return false;
      }
      if(date.password.length == 0){
        ElMessage({
          type: 'error',
          message: '密码不能为空'
        })
        this.fullScreenLoading = false;
        return false;
      }
      if (this.captchatoken) {
        if(!this.isVerify){
        ElMessage({
          type: 'error',
          message: '请完成拼图验证'
        })
        this.fullScreenLoading = false;
        return false;
      }
        date.moveLength = this.moveLength;
        date.imagecaptchatoken = this.imagecaptchatoken;
      }
      const obj = cloneDeep(date)
      // 使用新的加密方法替换原有的 sha1
      obj.password = encryptPassword(obj.password)
      if (this.value === 3) {
        const res = await getphonemultipleaccounts(obj)
        if (res.code === 0) {
          if (res.data.length === 0) {
            // 林总说的
            ElMessage({
              type: 'error',
              message: '用户不存在'
            })
            this.fullScreenLoading = false
            return
          } else if (res.data.length === 1) {
            this.toLogin(res, Num)
          } else if (res.data.length >= 1) {
            const list = res.data.map(item => {
              return {
                avatar: item.avatar,
                username: item.realname,
                userId: item.userId,
                sex: item.sex,
                usertype: item.usertype
              }
            })
            this.$emit('select-user', list)
            this.fullScreenLoading = false
          }
        } else {
          this.fullScreenLoading = false;
          ElMessage({
            type: 'error',
            message: res.msg
          })
          if (this.slideSuccessBtn || (res.data && res.data.num && res.data.num >= this.captchaNum)) {
            this.getCaptcha();
            this.slideBtnIsshow = true
            this.slideSuccessBtn = false
            this.isVerify = false
          }
        }
      } else {
        // this.toLogin(obj)
        const res = await this.accountAndIdLogin(obj)
        this.toLogin(res, Num)
      }
    },
    //- 获取token
    loginToken (schoolId, openId, accesstoken) {
      let date = {
        schoolId: schoolId,
        openId: openId,
        accesstoken: accesstoken
      };
      getaccesstoken(date)
        .then(res => {
          if (res.code === 0) {
            if (Number(res.data.login) === 0 || res.data.login === "" || res.data.resetpwd) {
              localStorage.setItem(
                "user",
                JSON.stringify({ apiurl: res.data.apiurl })
              );
              let val = {
                title: "重置密码",
                bottom: "确定",
                origin: "renewPaw",
                name: res.data.name,
                res: res
              };
              this.$emit("forgetPassword", val);
              this.fullScreenLoading = false;
              return false;
            }
            localStorage.setItem("user", JSON.stringify(res.data));
            document.cookie = "accesstoken=" + res.data.accesstoken + ";path=/";
            this.$router.push({ path: "/index" });
          } else {
            this.fullScreenLoading = false;
            ElMessage({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //- 忘记密码
    forgetPassword () {
      this.$emit("forgetPassword");
    },
    //- 获取登录验证码弹出条件
    getsecurityrules () {
      let that = this;
      getsecurityrules().then(res => {
        if (res.code === 0) {
          this.captchaNum = res.data.num
          if(res.data.top || res.data.num == 0){
            this.getCaptcha();
            this.slideBtnIsshow = true
          }
        } else {
          that.$message.error(res.msg);
        }
      })
      .catch(error => {
        console.log(error);
      });
      
    },
  },
  mounted () {
    this.captchatoken = '',
    this.captcha = ''
    // 获取登录验证码弹出条件
    this.getsecurityrules();
    // 国贸双因子认证需要，默认就需要输入验证码
    // if(this.$apiurl == 'http://app.itgedu.com.cn' || this.$apiurl == 'http://10.66.99.244' || this.$apiurl == 'http://10.66.99.244:8088'){
    //   this.getCaptcha();
    // }
   }
};
</script>

<style scoped lang="scss">
@import './common.scss';
::v-deep .el-input__prefix {
  left: 9px;
}
.toolItem {
  flex: 1;
  margin-bottom: 20px;
  text-align: center;
  font-size: 18px;
  font-family: MFLangQian_Noncommercial-Light, MFLangQian_Noncommercial;
}
::v-deep .el-input-div {
  position: relative;
  margin: 0 0 20px 0;
  width: 100%;
  display: inline-block;

  img {
    position: absolute;
    top: 10px;
    left: 25px;
    z-index: 999;
    height: 18px;
  }

  .el-select{
    .el-select__wrapper {
      height: 40px;
      padding-left: 58px;
      background-color: #f1f1f1;
      border-radius: 30px;
      border: none;
    }
  }

  .el-input {
    box-sizing: border-box;
    .el-input__wrapper {
      width: 100%;
      height: 40px;
      border-radius: 30px;
      border: none;
      .el-input__inner {
        overflow: hidden;
        height: 40px;
        line-height: 40px;
      }
    }
    input {
      border-radius: 30px;
    }
  }

  &:nth-child(1) {
    margin-top: 40px;
  }
  ::v-deep input::-webkit-input-placeholder{
    color: #999;
    -webkit-text-fill-color: #999;
  }
}
.loginBtn-blue {
  background: #4e86ff;
  border-color: #4e86ff;
}
.loginBtn-red {
  background: #E62E19;
  border-color: #E62E19;
}
.loginBtn-green {
  background: #0EA15F;
  border-color: #0EA15F;
}
.theme-blue {
  color: #4e86ff !important;
}
.theme-red {
  color: #E62E19 !important;
}
.theme-green {
  color: #0EA15F !important;
}
</style>
